module.exports = __webpack_public_path__ + "static/media/cad.81b05e03.svg";